<template>
    <div>
        <div class="sub-menu">
            <template v-if="type == 'bubble'">
                <a class="button dark text-white pointer" @click="open">sinottico</a>  
                <template v-if="selected != null">
                    <template v-if="selected.multidevice == undefined">
                        <a v-if="selected.department != undefined" :class="selected.machine != undefined ? 'button disabled': 'button primary disabled'" href="#3">{{ selected.department.name }}</a>
                        <a v-if="selected.machine != undefined" :class="selected.device != undefined ? 'button disabled': 'button primary disabled'" href="#3">{{ selected.machine.name }}</a>
                        <a v-if="selected.device != undefined" class="button primary disabled" href="#3">{{ selected.device.name }}</a>       
                    </template>
                    <template v-else>
                        <template v-for="(row, key) in selected.devices">
                            <a :key="key" v-if="row.name != undefined" class="button primary disabled" href="#3">{{ row.name }}</a>       
                        </template>
                    </template>
                </template>
            </template>
            <template v-else>
                <a class="button dark text-white col-md-12 pointer" @click="open">sinottico</a>   
                <template v-if="selected != null">
                    <template v-if="selected.department != undefined && selected.multidevice == undefined">
                        <a class="button primary synoptic-filter-btn col-md-12 disabled" v-html="selected.department.name + (selected.machine != undefined ? ' - ' + selected.machine.name: '') + (selected.device != undefined ? ' - ' + selected.device.name: '')"></a>
                    </template>
                    <template v-else>
                        <template v-for="(row, key) in selected.devices">
                            <a :key="key" class="button primary synoptic-filter-btn col-md-12 disabled" v-html="row.department.name + (row.machine != undefined ? ' - ' + row.machine.name: '') + (row.device != undefined ? ' - ' + row.device.name: '')"></a>
                        </template>
                    </template>
                </template>
            </template>
        </div>
        
        <div v-if="isOpen" class="synoptic">
            <div class="header">
                <div class="container container-menu">
                    <nav class="navbar navbar-expand-lg navbar-light bg-light">
                        <div class="btn-group menu"></div>
                        <a class="navbar-brand" href="#">
                            <img class="logo" src="assets/img/png/logo.png" alt="temeter" />
                        </a>
                        
                        <div class="user">
                            <span class="close-synoptic" @click="close">Chiudi</span>
                        </div>
                    </nav>
                </div>
            </div>
            
            <synoptic :page="page" :select-devices="selectDevices" :reset="reset" @close-synoptic="close"></synoptic>
        </div>
        
    </div>
</template>

<script>
    import Synoptic from "./Synoptic.vue";

    import { mapGetters } from 'vuex'

    export default {
        props: ['page', 'reset', 'type', 'selectDevices', 'selectedSiteId'],

        components: {Synoptic},

        data() {
            return {
                selected: null,
                isOpen: false
            }
        },

        created() {
            switch (this.page) {
                case 'dashboard': 
                    this.selected = this.selectedDashboard;
                    if(this.selected == null)
                        this.open();
                break;
                case 'acquisitions': this.selected = this.selectedAcquisitionsDevices; break;
                case 'consumptions': this.selected = this.selectedConsumptionsDevices; break;
                case 'alarms': this.selected = this.selectedAlarmsDevices; break;
            }
        },

        computed: {    
            ...mapGetters([
                'selectedSite',

                'selectedDashboard', 
                'selectedAcquisitionsDevices', 
                'selectedConsumptionsDevices', 
                'selectedAlarmsDevices', 
            ])
        },

        watch: {
            reset() {
                var selected = {}

                //Action salvo in storage il blocco
                var storeMethod = ''; 
                switch (this.page) {
                    case 'dashboard': storeMethod = 'changeMonitorDashboard'; break;
                    case 'acquisitions': storeMethod = 'changeAcquisitionsDevices'; break; // TO DO MODIFICARE con GetClientTree o similari quando pronta
                    case 'consumptions': storeMethod = 'changeConsumptionsDevices'; break;
                    case 'alarms': storeMethod = 'changeAlarmsDevices'; break;              
                }
                
                this.$store.dispatch(storeMethod, selected);
            },

            selectedDashboard() {
                if(this.selectedDashboard != null) {
                    this.selected = this.selectedDashboard;
                }
            },
            
            selectedAcquisitionsDevices() {
                if(this.selectedAcquisitionsDevices != null) {
                    this.selected = this.selectedAcquisitionsDevices;
                }
            },
            
            selectedConsumptionsDevices() {
                if(this.selectedConsumptionsDevices != null) {
                    this.selected = this.selectedConsumptionsDevices;
                }
            },
            
            selectedAlarmsDevices() {
                if(this.selectedAlarmsDevices != null) {
                    this.selected = this.selectedAlarmsDevices;
                }
            },

            selectedSite() {
                this.selected = null;
            }
        },

        methods: {
            open() {
                this.isOpen = true;
            },

            close() {
                this.isOpen = false;
            }  
        }
    };
</script>
